import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { RootState } from '../states/rootReducer';
import { 
  requestNotificationPermission, 
  getFCMToken, 
  onMessageListener,
  playNotificationSound 
} from '../services/FirebaseService';
import axiosInstance from '../services/BaseService';

const NotificationHandler: React.FC = () => {
  const { isAuthenticated, user } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (isAuthenticated && user) {
      initializeNotifications();
    }
  }, [isAuthenticated, user]);

  const initializeNotifications = async () => {
    try {
      console.log('🔔 Initializing notifications for user:', user);
      
      // Request permission
      console.log('🔐 Requesting notification permission...');
      const permissionGranted = await requestNotificationPermission();
      if (!permissionGranted) {
        console.log('❌ Notification permission denied');
        return;
      }
      console.log('✅ Notification permission granted');

      // Get FCM token
      console.log('🔑 Getting FCM token...');
      const token = await getFCMToken();
      if (!token) {
        console.log('❌ Failed to get FCM token');
        return;
      }
      console.log('✅ FCM token obtained:', token.substring(0, 20) + '...');

      // Update user's FCM token in backend
      console.log('📤 Updating FCM token in backend for authenticated user');
      await axiosInstance.post('/notifications/update-fcm-token', {
        fcmToken: token
      });

      console.log('✅ FCM token updated successfully');

      // Listen for foreground messages
      console.log('👂 Setting up message listener...');
      onMessageListener().then((payload: any) => {
        console.log('🔔 Foreground message received:', payload);
        
        // Play notification sound
        playNotificationSound();
        
        // Show toast notification
        toast.success(
          <div>
            <strong>{payload.notification?.title}</strong>
            <br />
            {payload.notification?.body}
          </div>,
          {
            position: "top-right",
            autoClose: 5000,
            onClick: () => {
              if (payload.data?.clickAction) {
                window.location.href = payload.data.clickAction;
              }
            }
          }
        );
      });

    } catch (error) {
      console.error('❌ Error initializing notifications:', error);
    }
  };

  return null; // This component doesn't render anything
};

export default NotificationHandler;